import { render, staticRenderFns } from "./AddToTampalan.vue?vue&type=template&id=50b34fc3&"
import script from "./AddToTampalan.vue?vue&type=script&lang=js&"
export * from "./AddToTampalan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports